import React, { useContext, useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import DocumentMeta from "react-document-meta";
import renderHTML from "react-render-html";
import { Link, useParams } from "react-router-dom";
import CommentForm from "../Components/Blog/CommentForm";
import CommentList from "../Components/Blog/CommentList";
import Loading from "./Loading";
import ContextComponent from "../Context";
import Statics from "../Statics";
import { FiExternalLink } from "react-icons/fi";

const Post = () => {
  const { post_id } = useParams();
  const { ApiDriver } = useContext(ContextComponent);

  const [loadingState, setLoadingState] = useState(Statics.NOT_LOADED);
  const [post, setPost] = useState(null);
  const [comments, setComments] = useState(null);
  const [pageMeta, setPageMeta] = useState({
    language: "fa",
    copyright: "پژوهیار",
    description: "نرم‌افزار استناددهی",
    meta: {
      charset: "utf-8",
      name: {
        keywords: "پژوهیار",
      },
    },
  });

  const postLog = () => {
    ApiDriver.sendBlogLogs("post_visit", "null", post_id, "blog");
  };

  const loadPost = () => {
    setLoadingState(Statics.LOADING);
    ApiDriver.getPost(
      { id: post_id },
      data => {
        setPost(data);
        setLoadingState(Statics.LOADED);

        const metaKeywords = data.tags
          ? data.tags.map(tag => tag.title).join(", ")
          : "";
        setPageMeta({
          title: `${document.title}: ${data.title}`,
          description: data.title,
          meta: {
            charset: "utf-8",
            name: {
              copyright: data.copyright,
              language: data.language,
              keywords: metaKeywords,
            },
          },
        });
      },
      error => {
        console.error(error);
        setLoadingState(Statics.CAUSED_ERROR);
      },
    );
  };

  const loadComments = () => {
    ApiDriver.getComments(
      { post_id },
      data => setComments(data),
      error => console.error(error),
    );
  };

  useEffect(() => {
    loadPost();
    loadComments();
    postLog();
    // eslint-disable-next-line
  }, [post_id]);

  return (
    <DocumentMeta {...pageMeta}>
      <div style={{ background: "#eee" }}>
        <Container className=" px-0 overflow-hidden text-right">
          <Row className="mx-0">
            <Col md={12} className=" mx-0 py-3">
              {loadingState === Statics.LOADING && (
                <div className="pajoohyar-loading">
                  <Loading />
                </div>
              )}
              {loadingState === Statics.CAUSED_ERROR ? (
                <div className="error-parent">
                  <p>ارتباط با سرور با مشکل مواجه شد !</p>
                </div>
              ) : null}

              {loadingState === Statics.LOADED && post && (
                <>
                  <div className="post-content">
                    <Link to="/blog" className="go-to-blog">
                      رفتن به صفحه اصلی بلاگ{" "}
                      <FiExternalLink className="blog-highlight-icon" />
                    </Link>
                    <div className="pt-3" style={{ textAlign: "center" }}>
                      <img
                        src={post.cover_pic_urls.lg}
                        style={{ maxHeight: "400px", width: "50%" }}
                        alt={post.title}
                      />
                    </div>
                    <div style={{ paddingTop: "50px", textAlign: "right" }}>
                      <h3>{post.title}</h3>
                    </div>
                    <div
                      className="outbox-content"
                      style={{ paddingTop: "50px", direction: "rtl" }}>
                      {renderHTML(post.body)}
                    </div>
                    <hr />
                    <div style={{ fontSize: "12px", color: "#a8a8b3" }}>
                      <span>نویسنده: {post.author_name}</span>
                    </div>
                  </div>

                  <div className="post-content mx-0 p-4 mt-4">
                    <CommentForm form_title="ارسال نظر" post_id={post.id} />
                  </div>

                  {comments && comments.length > 0 && (
                    <Row className="post-content mx-0 p-3 mt-4">
                      <Col>
                        <Row className="mx-0">
                          <Col>
                            <h2>نظرات کاربران</h2>
                          </Col>
                        </Row>
                        <hr />
                        <Row className="mx-0" style={{ paddingTop: "30px" }}>
                          <Col>
                            <CommentList
                              comments={comments}
                              post_id={post.id}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  )}
                </>
              )}
            </Col>
          </Row>
        </Container>
      </div>
    </DocumentMeta>
  );
};

export default Post;
